<template>
  <v-layout align-center column>
    <img
      src="../../assets/404/404-Illustration.png"
      srcset="
        ../../assets/404/404-Illustration@2x.png 2x,
        ../../assets/404/404-Illustration@3x.png 3x
      "
      class="-Illustration"
    />

    <p class="Page-Not-Found">Page Not Found</p>
    <p class="The-page-you-are-looking-for-might-have-been-remov">
      The page you are looking for might have been removed had it’s name changed
      or is temporarily unavailable.
    </p>
    <a href="/"
      ><div class="Shape"><p class="Shape-Text">Go To Homepage</p></div></a
    >
  </v-layout>
</template>
<script>
export default {};
</script>
<style scoped>
.-Illustration {
  width: 280px;
  height: 186.7px;
  flex-grow: 0;
  margin: 0 10px 16px;
  object-fit: contain;
}
.Page-Not-Found {
  width: 165px;
  height: 25px;
  flex-grow: 0;
  margin: 16px 67px 12px 68px;
  font-family: Sora;
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #d3352c;
}
.The-page-you-are-looking-for-might-have-been-remov {
  width: 300px;
  height: 60px;
  flex-grow: 0;
  margin: 12px 0 32px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Shape {
  width: 225px;
  height: 44px;
  flex-grow: 0;
  margin: 32px 37px 0 38px;
  padding: 14px 58px;
  border-radius: 26px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #252525;
}
.Shape-Text {
  width: 109px;

  height: 16px;

  flex-grow: 0;

  font-family: Inter;

  font-size: 13px;

  font-weight: bold;

  font-stretch: normal;

  font-style: normal;

  line-height: normal;

  letter-spacing: normal;

  text-align: center;

  color: #ffffff;
}
</style>
